/**
 * Custom sticky column
 */
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.is-style-sticky-section');
  const panel = document.querySelector('.is-style-sticky-panel');

  if (!section || !panel) return;
  if (window.innerWidth <= 781) return;

  const topOffset = 32; // 2rem approx

  function updateSticky() {
    const sectionRect = section.getBoundingClientRect();
    const sectionTop = window.scrollY + sectionRect.top;
    const sectionHeight = section.offsetHeight;
    const sectionBottom = sectionTop + sectionHeight;

	const stickPanel = panel.querySelector( '.wp-block-group' );

    const panelHeight = stickPanel.offsetHeight;
    const panelStart = sectionTop;
    const scrollTop = window.scrollY;

    const fixedStart = panelStart - topOffset;
    const fixedEnd = sectionBottom - panelHeight - topOffset;

    stickPanel.classList.remove('is-fixed', 'is-bottom');
    stickPanel.style.left = '';
    stickPanel.style.width = '';

    if (scrollTop < fixedStart) {
      return;
    }

    if (scrollTop >= fixedStart && scrollTop < fixedEnd) {
      const parentCol = stickPanel.parentElement;
      const parentRect = parentCol.getBoundingClientRect();

      stickPanel.classList.add('is-fixed');
      stickPanel.style.left = parentRect.left + 'px';
      stickPanel.style.width = parentRect.width + 'px';
      return;
    }

    if (scrollTop >= fixedEnd) {
      stickPanel.classList.add('is-bottom');
      return;
    }
  }

  function onResize() {
    stickPanel.classList.remove('is-fixed', 'is-bottom');
    stickPanel.style.left = '';
    stickPanel.style.width = '';

    if (window.innerWidth > 781) {
      updateSticky();
    }
  }

  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', onResize);

  updateSticky();
});
